export default "__VITE_ASSET__CXFAaDr2__"